<div
	class="pos"
	[ngStyle]="availability.styles"
	[ngClass]="{ posState: ['S', 'L', 'R'].includes(availability.state) }"
	*ngFor="let availability of availabilities"
	matTooltip="{{ availability.comment }}"
>
	{{ availability.comment }}
</div>
